import { render } from "./PanelTask.vue?vue&type=template&id=ce2c2414"
import script from "./PanelTask.vue?vue&type=script&lang=js"
export * from "./PanelTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__